import React, { memo } from "react";
import PropTypes from "prop-types";
import { TocList } from "discover.medical.react-component-library";
import HierarchyNode from "../HierarchyNode";

const Hierarchy = ({ hierarchy, topLevelCategory, className }) => {
  const hasChildren = hierarchy.some((item) => {
    return item.hasChildren;
  });

  return (
    <>
      <TocList
        className={className}
        parentType="button"
        hasMargin={hasChildren}
        backgroundColor={"gray100"}
      >
        {hierarchy.map((node) => {
          return (
            <HierarchyNode
              {...node}
              level={0}
              path={`${topLevelCategory}|${node.label}`}
              key={node.label}
            />
          );
        })}
      </TocList>
    </>
  );
};

Hierarchy.defaultProps = {
  hierarchy: [],
  topLevelCategory: "",
};

Hierarchy.propTypes = {
  hierarchy: PropTypes.array,
  topLevelCategory: PropTypes.string,
};

export default memo(Hierarchy);
